import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { activityDataProvider } from './dataProvider';

// 注册 activity/taskCategories模块的数据提供者
export function initActivityDataProvider() {
  registerModuleDataProvider('activityUserActivityStats', activityDataProvider);
}

// 自动初始化
initActivityDataProvider();
